import React from 'react';
import { GTMServices } from '@services/gtm';

import PropTypes from 'prop-types';

import {
  Wrapper,
  Logo,
  Button,
  Content,
  BannerText,
  ShapeContainer,
  TextButton,
  EndShape
} from './styles';

const Banner662 = ({
  document,
  image,
  bannerText,
  bannerBoldWords,
  redirectTo,
  bannerTextButton,
  buttonVisible
}) => {
  const updateTextWithBoldWords = () => {
    let bannerBoldWordsIndex = 0;
    return (
      <BannerText>
        {bannerText.split(' ').map(item => {
          let updatedText;

          if (item === '%STRONG%' && bannerBoldWords) {
            updatedText = (
              <strong>{`${bannerBoldWords[bannerBoldWordsIndex]} `}</strong>
            );
            bannerBoldWordsIndex += 1;
          } else {
            updatedText = `${item} `;
          }

          return updatedText;
        })}
      </BannerText>
    );
  };
  function handleDocumentLink() {
    GTMServices.dispatchGtm(
      'Circular 662',
      'Processos',
      'Banner Download',
      'Clique'
    );

    if (redirectTo === 'Pdf662') {
      window.open(document, '_blank');
    } else {
      window.open(redirectTo, '_blank');
    }
  }
  return (
    <Wrapper data-testid="banner-662">
      <Content>
        {updateTextWithBoldWords()}
        {buttonVisible && (
          <Button
            variant="outlined"
            disable={false}
            data-testid="download-pdf-662"
            onClick={() => handleDocumentLink()}
          >
            <TextButton>{bannerTextButton}</TextButton>
          </Button>
        )}
      </Content>

      <ShapeContainer>
        <EndShape />
        <Logo
          src={image}
          data-testid="logo-banner-662"
          alt="Logo - SUSEP circular 662"
        />
      </ShapeContainer>
    </Wrapper>
  );
};

export default Banner662;

Banner662.propTypes = {
  image: PropTypes.string.isRequired,
  document: PropTypes.string.isRequired,
  bannerText: PropTypes.string.isRequired,
  bannerBoldWords: PropTypes.arrayOf(PropTypes.string),
  redirectTo: PropTypes.string.isRequired,
  bannerTextButton: PropTypes.string.isRequired,
  buttonVisible: PropTypes.bool
};

Banner662.defaultProps = {
  bannerBoldWords: [],
  buttonVisible: true
};
